import { VFC, useMemo } from 'react';
import { isNil } from 'rambda';
import {
  CircuitBreakerSize,
  Phase,
  SinglePhaseCircuitBreakerSize,
  TriplePhaseCircuitBreakerSize,
} from '@enmon/commons';
import { useIntl } from 'react-intl';
import { Select } from '../../Select';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

export const getCircuitBreakerValues = (phase?: Phase | null): CircuitBreakerSize[] => {
  if (!phase) return [];

  return phase === 1 ? Object.values(SinglePhaseCircuitBreakerSize) : Object.values(TriplePhaseCircuitBreakerSize);
};

interface CircuitBreakerSizeSelectProps {
  value?: CircuitBreakerSize;
  onChange?: (value: CircuitBreakerSize) => void;
  phases?: Phase | null;
}

export const CircuitBreakerSizeSelect: VFC<CircuitBreakerSizeSelectProps> = ({ phases, ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const circuitBreakerSizeOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: getCircuitBreakerValues(phases),
        suggestedValue: meterModelSuggestions?.circuitBreakerSize?.value,
        suggestedSelection: meterModelSuggestions?.circuitBreakerSize?.selection,
      }),
    [meterModelSuggestions, phases, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      disabled={isNil(phases)}
      options={circuitBreakerSizeOptions}
      placeholder={phases === 1 ? SinglePhaseCircuitBreakerSize['J-1x25'] : TriplePhaseCircuitBreakerSize['T-3x25']}
      suffix="A"
      {...restProps}
    />
  );
};
